
import { Table, Badge, Button } from 'react-bootstrap';
import { 
  FaSort, 
  FaSortUp, 
  FaSortDown,
  FaFileAlt,
  FaUserCircle,
  FaFilePdf
} from 'react-icons/fa';

const TransactionTable = ({ 
  transactions, 
  currentSort, 
  sortDirection, 
  onSort 
}) => {
  // Formater la date
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  };

  // Formater la devise
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'XAF',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(amount);
  };

  // Obtenir l'icône de tri
  const getSortIcon = (field) => {
    if (currentSort !== field) return <FaSort className="text-muted" />;
    return sortDirection === 'asc' ? <FaSortUp /> : <FaSortDown />;
  };

  return (
    <div className="table-responsive">
      <Table hover className="align-middle mb-0 table-striped table-hover">
        <thead className="bg-light">
          <tr>
            <th style={{ width: '12%' }}>
              <Button
                variant="link"
                className="p-0 text-decoration-none text-dark fw-semibold"
                onClick={() => onSort('date')}
              >
                Date {getSortIcon('date')}
              </Button>
            </th>
            <th style={{ width: '15%' }}>
              <Button
                variant="link"
                className="p-0 text-decoration-none text-dark fw-semibold"
                onClick={() => onSort('reference')}
              >
                Référence {getSortIcon('reference')}
              </Button>
            </th>
            <th style={{ width: '25%' }}>Client Débiteur</th>
            <th style={{ width: '25%' }}>Client Créditeur</th>
            <th style={{ width: '8%' }}>
              <Button
                variant="link"
                className="p-0 text-decoration-none text-dark fw-semibold"
                onClick={() => onSort('quantity')}
              >
                Qté {getSortIcon('quantity')}
              </Button>
            </th>
            <th style={{ width: '15%' }}>
              <Button
                variant="link"
                className="p-0 text-decoration-none text-dark fw-semibold"
                onClick={() => onSort('value')}
              >
                Valeur {getSortIcon('value')}
              </Button>
            </th>
            <th>Documents</th>
          </tr>
        </thead>
        <tbody>
          {transactions.map((transaction, index) => (
            <tr key={transaction.transactionReference} className="hover-row">
              <td>
                <div className="d-flex align-items-center">
                  <div className="bg-primary bg-opacity-10 rounded p-2 me-2">
                    <FaFileAlt className="text-white" size={14} />
                  </div>
                  <div>
                    <div className="fw-semibold">
                      {formatDate(transaction.transactionDate)}
                    </div>
                    <Badge bg="light" text="dark" className="border">
                      {transaction.transactionType}
                    </Badge>
                  </div>
                </div>
              </td>
              
              <td>
                <code className="text-primary">
                  {transaction.transactionReference}
                </code>
              </td>
              
              <td>
                <div className="d-flex align-items-center">
                  <FaUserCircle className="text-danger me-2" />
                  <div>
                    <div className="fw-medium text-truncate" style={{ maxWidth: '200px' }}>
                      {transaction.sourceClient?.displayName || 'N/A'}
                    </div>
                    <small className="text-muted">
                      {transaction.debitLabel || 'Débit'}
                    </small>
                  </div>
                </div>
              </td>
              
              <td>
                <div className="d-flex align-items-center">
                  <FaUserCircle className="text-success me-2" />
                  <div>
                    <div className="fw-medium text-truncate" style={{ maxWidth: '200px' }}>
                      {transaction.destinationClient?.displayName || 'N/A'}
                    </div>
                    <small className="text-muted">
                      {transaction.creditLabel || 'Crédit'}
                    </small>
                  </div>
                </div>
              </td>
              
              <td className="text-end fw-semibold">
                {transaction.quantity.toLocaleString('fr-FR')}
              </td>
              
              <td className="text-end">
                <div className="fw-bold text-success">
                  {formatCurrency(transaction.totalValue)}
                </div>
                <small className="text-muted">
                  {formatCurrency(transaction.unitValue)}/unité
                </small>
              </td>

              {transaction.documents && transaction.documents.length > 0 ? (
                <td>
                  <div className="d-flex gap-1">
                    {transaction.documents.map((doc, idx) => (
                      <Button
                        key={idx}
                        variant="outline-primary"
                        size="sm"
                        href={doc.url}
                        target="_blank"
                        className="px-2 py-1"
                      >
                        <FaFilePdf />
                      </Button>
                    ))}
                  </div>
                </td>
              ) : (
                <td>
                  <span className="text-muted small">Aucun document</span>
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default TransactionTable;